import type { ValidCurrency } from '@/types/plans';
import { getLocaleForCurrency } from './getLocaleForCurrency';

/**
 * The decimal mark a price in this currency is written with, e.g. `.` for GBP,
 * `,` for BRL. Note EUR maps to `en-IE`, so it comes back as `.` — most of the
 * eurozone writes `8,99`, but the site has no i18n locale (every
 * `formatCurrency` caller falls back to `en-GB`) and API prices are
 * dot-decimal, so a comma here would disagree with every other price on the
 * page. Change the mapping, not this, if EUR should localise properly.
 */
export function getDecimalSeparator(currency: ValidCurrency): string {
  const separator = new Intl.NumberFormat(getLocaleForCurrency(currency), {
    style: 'currency',
    currency,
  })
    .formatToParts(0.1)
    .find((part) => part.type === 'decimal');

  return separator?.value ?? '.';
}
